module.exports = __webpack_public_path__ + "11a27cbc6af076f16dc27ffdb21cbe78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/quote-dark-gray.svg
// module id = 13
// module chunks = 0